<script setup>
// import { inject } from 'vue'

const getImageSrc = (image) => {
  return (new URL(`../../assets/images/main_page/${image}`, import.meta.url)).href
}
// const studentPanelBaseUrl = inject('studentBaseUrl');

</script>
<template>
  <v-container tag="section" class="cl__section__margin__bottom">
    <v-row class="mb-8">
      <v-col cols="12" class="d-flex justify-center text-center flex-column align-center">
        <h1 class="font-weight-bold cl-section__title" :class="[!$vuetify.display.mdAndDown ? 'mb-10' : '']" style="color: rgba(104, 109, 122, 1)">
          چرا <span class="text-dark">کلاس آنلاین</span> با <span class="text-dark">کلاسینو</span> بهترین انتخابه؟
        </h1>
        <p class="cl__section__subtitle">
          از <strong>ابتدایی تا کنکور</strong> همراهت هستیم! اگه می‌خوای درس‌ها رو با <strong>بهترین اساتید کنکور و پایه</strong> با بهترین روش یاد بگیری، معطل نکن! تو <strong>کلاس آنلاین</strong> کلاسینو همه‌چی فرق داره تا بتونی آموزش مجازی رو حتی بهتر از کلاس‌های حضوری تجربه کنی.
        </p>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-space-around">
      <v-col cols="12" lg="3" md="6" class="d-flex justify-center" >
        <v-card variant="text" max-width="336px" :class="[$vuetify.display.mdAndDown?'d-flex flex-column align-center':'']">
          <v-img
            :width="$vuetify.display.mdAndDown? '45%':''"
            :src="getImageSrc('maghate.png')"
            alt="classino all grades"
          />
          <v-card-title  class="why__section__title mt-3 font-weight-bold text-wrap">
            از اول دبستان تا کنکور سراسری
          </v-card-title>
          <v-card-title class="why__section__subtitle text-wrap font-weight-light" :class="$vuetify.display.mdAndDown? 'text-center':''">
            فرقی نداره کلاس چندمی! برای همه مقاطع تحصیلی برنامه‌های ویژه داریم و کمکت می‌کنیم به هدفت برسی.
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="6" class="d-flex justify-center" :class="$vuetify.display.mdAndDown?'mt-5':''">
        <v-card variant="text" :class="[$vuetify.display.mdAndDown?'d-flex flex-column align-center':'']" max-width="336px">
          <v-img
            :width="$vuetify.display.mdAndDown? '45%':''"
            :src="getImageSrc('dastresi.png')"
            alt="classino online access"
          />
          <v-card-title class="why__section__title mt-3 font-weight-bold px-0 text-wrap">
            دسترسی آنلاین، هر جا که باشی
          </v-card-title>
          <v-card-title class="why__section__subtitle text-wrap px-0 font-weight-light" :class="$vuetify.display.mdAndDown? 'text-center':''">
            با گوشی، تبلت یا لپ‌تاپ، هر جا که هستی می‌تونی به کلاس‌های باکیفیت دسترسی داشته باشی.
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="6" class="d-flex justify-center" :class="$vuetify.display.mdAndDown?'mt-5':''">
        <v-card variant="text" max-width="336px" :class="[$vuetify.display.mdAndDown?'d-flex flex-column align-center':'']">
          <v-img
            :width="$vuetify.display.mdAndDown? '45%':''"
            :src="getImageSrc('goftogoo.png')"
            alt="classino question and answer"

          />
          <v-card-title class="why__section__title mt-3 font-weight-bold px-0 text-wrap">
            پشتیبانی و رفع اشکال همیشگی
          </v-card-title>
          <v-card-title class="why__section__subtitle text-wrap px-0 font-weight-light" :class="$vuetify.display.mdAndDown? 'text-center':''">
            سوال داری؟ مشکلی هست؟ توی فضای تعاملی کلاس‌های آنلاین ما، اساتید در لحظه به سوالاتت پاسخ میدن.
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="6" class="d-flex justify-center" :class="$vuetify.display.mdAndDown?'mt-5':''">
        <v-card variant="text" max-width="336px" :class="[$vuetify.display.mdAndDown?'d-flex flex-column align-center':'']">
          <v-img
            :width="$vuetify.display.mdAndDown? '45%':''"
            :src="getImageSrc('asatid.png')"
            alt="classino professors "
          />
          <v-card-title class="why__section__title mt-3 font-weight-bold px-0 text-wrap">
            بهترین اساتید با روش خاص
          </v-card-title>
          <v-card-title class="why__section__subtitle text-wrap px-0 font-weight-light" :class="$vuetify.display.mdAndDown? 'text-center':''">
            تو کلاسینو قراره برترین و باتجربه‌ترین اساتید رو با روش‌های نوین آموزشی تجربه کنی.
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<style lang="scss" scoped>
.why__section__title{
  font-size: 28px;
  @include media-breakpoint-down(md){
    font-size: 24px
  }
}
.why__section__subtitle{
  font-size: 24px;
  @include media-breakpoint-down(md){
    font-size: 14px
  }
}
</style>
